/**
 * Created by 11 on 2017/4/26.
 * author wf
 */
//-------正则验证 util---------/
export  default {
    install(Vue){
        //验证输入不能为空格
        Vue.prototype.validatorSpace=function(rule, value, callback){
            var regu = "^[ ]+$";
            var re = new RegExp(regu);
            if (re.test(value)) {
                callback(new Error('不能为空字符'));
            } else {
                callback();
            }
        }
        Vue.prototype.validatorPhone=function(rule, value, callback){
          /*  var regu = "^1|[3|4|5|7|8][0-9]\\d{8}$";
            var re = new RegExp(regu);*/
            if (!(/^1[3|4|5|7|8][0-9]\d{8}$/.test(value))) {
                callback(new Error('手机号不符合规则'));
            } else {
                callback();
            }
        }
        Vue.prototype.validateFileList = (rule, value, callback) => {
            debugger
            //var fileType=this.materiaForm.resource_upload_type;
            //console.log(value.length+"fileType"+fileType);

            if (value.length == 0 ) {
                callback(new Error('请选择资源...'));
            }else {
                callback();
            }
        };
        Vue.prototype.validatorNetwork=function(rule, value, callback){
            /*var regu = "^(https|http|ftp|rtsp|mms)?://$";
            var re = new RegExp(regu);
            if (re.test(value)) {
                callback(new Error('请输入正确的网址'));
            } else {
                callback();
            }*/
            if(value==""){
                callback(new Error('在线地址不能为空'));
            }
            else if(   value.indexOf("http://")==-1 &&
                 value.indexOf("https://")==-1 ){
                callback(new Error('请输入正确的网址 http://开头或 https://开头'));
            }else {
                callback();
            }
        }

        //不能含有特殊字符
        Vue.prototype.validatorCharmap=function(rule, value, callback){
            var regu="[`~!#$^&*=|':;',\\<>/?~！@#￥……&*（）——|{}‘；：”“’。，、？]";
            var re = new RegExp(regu);
            var arr=re.exec(value);//返回一个数组 下标0 是匹配的字符
            value.replace(regu, function() {
                console.log(arguments.length); //5
                console.log(arguments[1]);//test
            });
            if (re.test(value)) {
                callback(new Error('不能含有特殊字符  '+arr[0]));
            } else {
                callback();
            }
        }
    }
}




// WEBPACK FOOTER //
// ./src/store/validator.js